export class PAWorkFlowSearchModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class PAWorkFlowSearch extends PAWorkFlowSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
